import SingleInfo from "./SingleInfo"

export type InfoType = {
    id: number,
    img_url: string,
    isVideo: boolean,
    title: string,
    subtitle: string
}

const Infos = () => {

    const infos:Array<InfoType> = [
        {
            id: 1,
            img_url: '',
            isVideo: true,
            title: 'WHO WE ARE',
            subtitle: 'TWO DESIGN NERDS FROM GRAZ, STUDYING AT FH JOANNEUM – BUT WAY PAST “JUST STUDENTS.” WE LOVE BOLD IDEAS, WEIRD AESTHETICS, AND VISUALS THAT MAKE YOU STOP SCROLLING. NOT HERE TO PLAY IT SAFE. HERE TO MAKE “TOO MUCH”.'
        },
        {
            id: 2,
            img_url: '',
            isVideo: true,
            title: 'OUR PASSION',
            subtitle: 'DESIGN SHOULD FEEL – TRIGGER A SMILE, A THOUGHT, OR EVEN A “WTF”. THAT’S WHY WE GO ALL IN: FULL FOCUS, WEIRD IDEAS, CLEAN EXECUTION. BRANDING, MOTION, WEB – WHATEVER IT IS, WE TURN IDEAS INTO EXPERIENCES THAT HIT. WE DON’T JUST DESIGN. WE COLLABORATE. WE PROVOKE. WE OBSESS.'
        },
        {
            id: 3,
            img_url: 'head_richtig02.gif',
            isVideo: false,
            title: 'BASTIAN HOCHSTRASSER',
            subtitle: 'BASTIAN’S WORK STANDS OUT – BOLD, UNIQUE, NEVER RANDOM. COLORFUL WITH A SYSTEM BEHIND THE CHAOS: STRUCTURED, YET WILD. HE BRINGS CLARITY TO COMPLEXITY AND TURNS IDEAS INTO VISUALS THAT STICK.'
        },
        {
            id: 4,
            img_url: 'jayrichtig02.gif',
            isVideo: false,
            title: 'JAKOB ELIA GÖSLBAUER',
            subtitle: 'JAKOB (ALIAS FYN) MERGES SOUND AND VISUALS INTO ONE LANGUAGE. WITH A BACKGROUND IN SOUND DESIGN AND A STRONG FOCUS ON 3D AND LIVE VISUALS, HE CREATES MINIMAL, BLACK-AND-WHITE WORLDS BUILT FROM LINES, GEOMETRY, AND MOTION. HIS STYLE IS PRECISE, REDUCED, AND UNMISTAKABLY HIS. IT DOESN’T SCREAM – BUT IT RESONATES.'
        }
    ]

    return(
        <div className="w-full px-4 md:px-16 lg:px-24 xl:px-32 flex flex-col gap-16 md:gap-0" id="infos">
            {
                infos.map((info ,index) => {
                    return <SingleInfo info={info} key={index}/>
                })
            }
        </div>
    )
}

export default Infos
